import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { JBMButtonsModule } from 'src/app/components/JBM/Buttons/jbmbuttons.module';
import { JBMFormModule } from 'src/app/components/JBM/Forms/jbmform.module';
import { JBMModalModule } from 'src/app/components/JBM/JBMModal/jbmmodal.module';
import { JBMViewModule } from "../../components/JBM/Views/jbmview.module";
import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsComponent } from './settings.component';
import {LayoutModule} from '../../layout/layout.module';
import { UserPreferencesComponent } from './userPreferences/userPreferences.component';

@NgModule({
  declarations: [SettingsComponent, UserPreferencesComponent],
  imports: [CommonModule, SettingsRoutingModule, SharedModule, JBMButtonsModule, JBMFormModule, JBMModalModule, 
    JBMViewModule, LayoutModule]
})
export class SettingsModule { }
